import * as DialogPrimitive from '@radix-ui/react-dialog';
import { Lineicons } from '@lineiconshq/react-lineicons';
import { XmarkStroke } from '@lineiconshq/free-icons';
import { Dialog, DialogOverlay, DialogPortal, DialogTitle } from '@/components/ui/dialog';
import { AritoFormV2, AritoIcon, BottomActionBarV2 } from '@/components/custom/erp';
import { useDialogStack } from '@/hooks/use-dialog-stack';
import BasicInfoTab from './BasicInfoTab';

interface InitialSearchDialogProps {
  open: boolean;
  formMode: 'add' | 'edit' | 'view';
  initialData?: MuaHangRecord;
  onClose: () => void;
  onSearch: (values: MuaHangRecord) => void;
}

const InitialSearchDialog = ({ open, formMode, initialData, onClose, onSearch }: InitialSearchDialogProps) => {
  const { contentZIndex, overlayZIndex } = useDialogStack(open);

  const handleSubmit = (data: MuaHangRecord) => {
    onSearch(data);
    onClose();
  };

  return (
    <Dialog modal={true} open={open} onOpenChange={onClose}>
      <DialogPortal>
        <DialogOverlay className='fixed inset-0 bg-black/50' style={{ zIndex: overlayZIndex }} />
        <div className='fixed inset-0 flex items-center justify-center p-4' style={{ zIndex: contentZIndex }}>
          <DialogPrimitive.Content
            onOpenAutoFocus={event => event.preventDefault()}
            onCloseAutoFocus={event => event.preventDefault()}
            onInteractOutside={event => event.preventDefault()}
            onPointerDownOutside={event => event.preventDefault()}
            onFocusOutside={event => event.preventDefault()}
            className='flex max-h-[85vh] w-[820px] flex-col overflow-hidden border border-[#cfd8e3] bg-white shadow-lg outline-none'
          >
            <div className='flex h-11 min-h-11 items-center justify-between border-b border-[#d1d5db] bg-[#f2f7fc] pl-3.5 pr-4'>
              <DialogTitle className='flex items-center text-[16px] font-bold text-black'>
                <AritoIcon icon={699} className='mx-2' />
                <span>Điều kiện lọc</span>
              </DialogTitle>
              <button type='button' onClick={onClose} className='inline-flex size-8 items-center justify-center'>
                <Lineicons aria-hidden='true' icon={XmarkStroke} className='size-[18px]' />
              </button>
            </div>
            <AritoFormV2<MuaHangRecord>
              mode={formMode}
              initialData={initialData || {}}
              hasAritoActionBar={false}
              className='!static !w-full'
              onSubmit={handleSubmit}
              onClose={onClose}
              headerFields={
                <div className='max-h-[calc(100vh-250px)] w-[800px] min-w-[800px] overflow-y-auto'>
                  <BasicInfoTab formMode={formMode} />
                </div>
              }
              bottomBar={
                <BottomActionBarV2
                  mode={formMode === 'view' ? 'view' : 'search'}
                  onClose={onClose}
                  submitTitle='Đồng ý'
                />
              }
            />
          </DialogPrimitive.Content>
        </div>
      </DialogPortal>
    </Dialog>
  );
};

export default InitialSearchDialog;
